import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { billingQueryKeys, createWebExpense } from '../api/billing.api';
import type { CreateWebExpensePayload } from '../types/billing.types';

export function useCreateWebExpense(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateWebExpensePayload) => createWebExpense(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: billingQueryKeys.all() });
      toast.success('Expense saved');
      onSuccess?.();
    },
    onError: (error) => showApiErrorToast(error, 'Could not save the expense'),
  });
}
